class BoutiqueNavigation extends HTMLElement {
  constructor () {
    super()

    this.sectionExternalEls = window.BAO.utils.getElements(
      '[data-external-el="boutique-navigation.section"]'
    )
    this.itemsEl = window.BAO.utils.getElement(
      '[data-el="boutique-navigation.items"]'
    )
    this.buttonEls = window.BAO.utils.getElements(
      '[data-el="boutique-navigation.button"]'
    )

    this.sectionExternalEls.forEach(section => {
      this.buildItems(section.dataset.boutiqueNavigationTitle)
    })

    this.buttonEls.forEach(button => {
      button.addEventListener('click', this.onClick.bind(this))
    })
  }

  buildItems (link) {
    const item = document.createElement('li')
    item.classList.add('sec-BoutiqueNav_Item')

    const button = document.createElement('button')
    button.classList.add('sec-BoutiqueNav_Link', 'fz-12_18')
    button.setAttribute('data-el', 'boutique-navigation.button')
    button.appendChild(document.createTextNode(link))

    item.appendChild(button)

    this.itemsEl.appendChild(item)

    this.buttonEls = window.BAO.utils.getElements(
      '[data-el="boutique-navigation.button"]'
    )

    this.observeItems()
  }

  observeItems () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7,
    }

    function observerCallback (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const navItem = Array.from(
            document.querySelectorAll('[data-el="boutique-navigation.button"]')
          ).find(
            el =>
              el.textContent === entry.target.dataset.boutiqueNavigationTitle
          )

          navItem.classList.add('sec-BoutiqueNav_Link-active')
          document
            .querySelectorAll('[data-el="boutique-navigation.button"]')
            .forEach(item => {
              if (item !== navItem) {
                item.classList.remove('sec-BoutiqueNav_Link-active')
              }
            })
        }
      })
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.sectionExternalEls.forEach(sec => observer.observe(sec))
  }

  onClick (e) {
    window.scrollTo({
      top: window.BAO.utils.getOffsetTop(
        window.BAO.utils.getElement(
          `[data-boutique-navigation-title="${e.target.firstChild.nodeValue}"]`
        )
      ),
      left: 0,
      behavior: 'smooth',
    })
  }
}

customElements.define('boutique-navigation', BoutiqueNavigation)
